import { faEdit } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
const InvestmentsCardView = (data) => {
  {
    return (data?.data ?? []).map((investment) => (
      <div>
        <p className="investment-name">{investment?.investmentName ?? ""}</p>
        <div className="Investment-card">
          <div className="source-flex-column">
            <p className="Investment-heading">Balance</p>
            <p className="Investment-value">
              ${" "}
              {(investment?.investmentAccountBalance ?? 0).toLocaleString(
                undefined,
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
            </p>
          </div>

          <div className="Investment-horizontal-bar">
            <p className="Investment-heading">NAV</p>
            <p className="Investment-value">
              ${/* {investment?.nav} */}
              {(
                (investment?.investmentAccountBalance ?? 0) /
                (investment?.basisBalanceUnits +
                  investment?.regularBalanceUnits +
                  investment?.repaymentBalanceUnits)
              )?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
          <div className="Investment-horizontal-bar">
            <p className="Investment-heading">Units</p>
            <p className="Investment-value">
              {(
                investment?.basisBalanceUnits +
                investment?.regularBalanceUnits +
                investment?.repaymentBalanceUnits
              )?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
          <div className="Investment-horizontal-bar">
            <p className="Investment-heading">Gross Loan Amount</p>
            <p className="Investment-value">
              ${" "}
              {(investment?.grossWithdrawalAmount ?? 0)?.toLocaleString(
                undefined,
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
            </p>
          </div>
          <div className="Investment-horizontal-bar">
            <p className="Investment-heading">Net Request Amount</p>
            <p className="Investment-value">
              ${" "}
              {(investment?.requestedAmount ?? 0).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
        </div>
      </div>
    ));
  }
};

export default InvestmentsCardView;
